import type { HelpFile } from '../../types/help'
import { TypesTestIds } from '../../../testids/TypesTestIds'

export const typesHelp: HelpFile = {
  docPage: '/docs/schema/types',
  texts: {
    [TypesTestIds.typesPage]:
      'Entity types defined in the schema — the building blocks for parties, identities, accounts, and any custom domain objects.',
  },
}
